/* Little Senses theme — interactions (no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* Sticky header shadow ---------------------------------------------- */
  const header = $('.header-wrapper--sticky');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu -------------------------------------------------------- */
  const mobileNav = $('#MobileNav');
  $$('[data-menu-open]').forEach((btn) =>
    btn.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      document.body.classList.add('no-scroll');
      btn.setAttribute('aria-expanded', 'true');
      const close = $('[data-menu-close]', mobileNav);
      if (close) close.focus();
    })
  );
  $$('[data-menu-close]').forEach((btn) =>
    btn.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    })
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      $('[data-menu-close]', mobileNav).click();
    }
  });

  /* Quantity steppers -------------------------------------------------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    $$('button', wrap).forEach((btn) =>
      btn.addEventListener('click', () => {
        const step = btn.dataset.step === 'up' ? 1 : -1;
        const min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    );
  });

  /* Cart: auto-update on quantity change ------------------------------ */
  const cartForm = $('#CartForm');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 450);
    });
  }

  /* Product gallery ---------------------------------------------------- */
  $$('[data-gallery]').forEach((gallery) => {
    const items = $$('.product__media-item', gallery);
    const thumbs = $$('.product__thumb', gallery);
    const show = (id) => {
      items.forEach((el) => el.classList.toggle('is-active', el.dataset.mediaId === id));
      thumbs.forEach((el) => el.setAttribute('aria-current', el.dataset.mediaId === id ? 'true' : 'false'));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.mediaId)));
    gallery.addEventListener('gallery:show', (e) => e.detail && show(String(e.detail)));
  });

  /* Variant picker ----------------------------------------------------- */
  $$('[data-product-form]').forEach((form) => {
    const json = $('[data-variants]', form.closest('[data-product]') || document);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', form);
    const submit = $('[data-add-button]', form);
    const scope = form.closest('[data-product]');
    const priceEl = scope && $('[data-price]', scope);
    const compareEl = scope && $('[data-compare]', scope);
    const gallery = scope && $('[data-gallery]', scope);

    const money = (cents) => {
      const fmt = (scope && scope.dataset.moneyFormat) || '${{amount}}';
      const value = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) =>
        key.indexOf('comma') > -1 ? value.replace('.', ',') : key.indexOf('no_decimals') > -1 ? Math.round(cents / 100) : value
      );
    };

    form.addEventListener('change', (e) => {
      if (!e.target.closest('.variant-picker')) return;
      const selected = $$('.variant-picker', form).map((fs) => {
        const c = $('input:checked', fs);
        return c ? c.value : null;
      });
      const v = variants.find((variant) => variant.options.every((opt, i) => opt === selected[i]));
      if (!v) {
        submit.disabled = true;
        submit.querySelector('span').textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      submit.disabled = !v.available;
      submit.querySelector('span').textContent = v.available ? submit.dataset.label : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      }
      if (gallery && v.featured_media) gallery.dispatchEvent(new CustomEvent('gallery:show', { detail: v.featured_media.id }));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Sticky add to cart ------------------------------------------------- */
  const sticky = $('[data-sticky-atc]');
  const mainButton = $('[data-add-button]');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    const footer = $('.footer');
    let pastButton = false;
    let footerVisible = false;
    const update = () => sticky.classList.toggle('is-visible', pastButton && !footerVisible);
    new IntersectionObserver(([entry]) => {
      pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(mainButton);
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; update(); }).observe(footer);
    const stickyBtn = $('button', sticky);
    if (stickyBtn) stickyBtn.addEventListener('click', () => mainButton.click());
  }

  /* Look inside: scroll buttons + lightbox ----------------------------- */
  $$('[data-look-inside]').forEach((section) => {
    const track = $('.look-inside__track', section);
    $$('[data-scroll]', section).forEach((btn) =>
      btn.addEventListener('click', () => {
        const dir = btn.dataset.scroll === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      })
    );
  });

  const lightbox = $('#Lightbox');
  if (lightbox && typeof lightbox.showModal === 'function') {
    const img = $('.lightbox__img', lightbox);
    let group = [];
    let index = 0;
    const render = () => {
      const btn = group[index];
      img.src = btn.dataset.full;
      img.alt = btn.dataset.alt || '';
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lightbox]');
      if (!btn) return;
      const scope = btn.closest('[data-look-inside]') || document;
      group = $$('[data-lightbox]', scope);
      index = group.indexOf(btn);
      render();
      lightbox.showModal();
    });
    $('[data-lightbox-close]', lightbox).addEventListener('click', () => lightbox.close());
    $('[data-lightbox-prev]', lightbox).addEventListener('click', () => { index = (index - 1 + group.length) % group.length; render(); });
    $('[data-lightbox-next]', lightbox).addEventListener('click', () => { index = (index + 1) % group.length; render(); });
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) lightbox.close(); });
    lightbox.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') $('[data-lightbox-next]', lightbox).click();
      if (e.key === 'ArrowLeft') $('[data-lightbox-prev]', lightbox).click();
    });
  }

  /* Reveal on scroll --------------------------------------------------- */
  const reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }
  if (window.Shopify && window.Shopify.designMode) reveals.forEach((el) => el.classList.add('is-in'));
})();
